<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useAdminFiltersStore } from '@/stores/adminFilters'

const adminFilters = useAdminFiltersStore()
const { selectedYear, yearOptions } = storeToRefs(adminFilters)
</script>

<template>
  <VSelect
    v-model="selectedYear"
    :items="yearOptions"
    density="compact"
    hide-details
    single-line
    class="year-select"
  />
</template>

<style scoped>
.year-select {
  flex-shrink: 0;
  inline-size: 90px;
  min-inline-size: 0;
}
</style>
